var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 31 26" }, props),
    React.createElement("path", { className: styles["oc-icon-burger"] || "oc-icon-burger", d: "M1.3.2h28.5c.5 0 1 .4 1 1v3.1c0 .5-.4 1-1 1H1.3c-.5 0-1-.4-1-1V1.1c0-.5.4-.9 1-.9zM1.3 10.5h28.5c.5 0 1 .4 1 1v3.1c0 .5-.4 1-1 1H1.3c-.5 0-1-.4-1-1v-3.1c0-.6.4-1 1-1zM1.3 20.8h28.5c.5 0 1 .4 1 1v3.1c0 .5-.4 1-1 1H1.3c-.5 0-1-.4-1-1v-3.1c0-.6.4-1 1-1z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Burger.svg